import { environment } from '../../environments/environment';

export class ApiUrls {
  private static readonly BASE_URL = environment.apiBaseUrl;

  // Auth endpoints
  static readonly SEND_OTP = `${ApiUrls.BASE_URL}/v1/auth/login/SendOtp`;
  static readonly LOGIN = `${ApiUrls.BASE_URL}/v1/auth/login/Login`;
  static readonly ME = `${ApiUrls.BASE_URL}/v1/auth/me`;
  static readonly REFRESH = `${ApiUrls.BASE_URL}/v1/auth/login/refresh`;
  static readonly LOGOUT = `${ApiUrls.BASE_URL}/v1/auth/logout`;

  // Contract endpoints
  static readonly CONTRACTS = `${ApiUrls.BASE_URL}/api/Contract/contracts`;
  static readonly CONTRACT_Details =`${ApiUrls.BASE_URL}/api/Contract/contractDetails`;
  static readonly CONTRACTS_DOWNLOAD = `${ApiUrls.BASE_URL}/api/Contract/download`;

  // Revenue Per Track endpoints
  static readonly CONTRACT_REVENUE_TIMELINE   = `${ApiUrls.BASE_URL}/api/Contract`;
  static readonly CONTRACT_REVENUE_DETAIL     = `${ApiUrls.BASE_URL}/api/Contract`;
  static readonly CONTRACT_REVENUE_ALL_TRACKS = `${ApiUrls.BASE_URL}/api/Contract`;

  // Dashboard endpoints
  static readonly DASHBOARD = `${ApiUrls.BASE_URL}/api/Dashboard`;

  // Royalties endpoints
  static readonly ROYALTIES_STATEMENTS = `${ApiUrls.BASE_URL}/api/Royalties/statements`;
  static readonly ROYALTIES_PLATFORM_DETAILS = `${ApiUrls.BASE_URL}/api/Royalties/platform-details`;
  static readonly ROYALTIES_TRACK_DETAILS = `${ApiUrls.BASE_URL}/api/Royalties/track-details`;
  static readonly ROYALTIES_EARNINGS = `${ApiUrls.BASE_URL}/api/Royalties/earnings/monthly`;
  static readonly ROYALTIES_PERIODS = `${ApiUrls.BASE_URL}/api/Royalties/periods`;
  static readonly ROYALTIES_PAYMENTS = `${ApiUrls.BASE_URL}/api/Royalties/payments`;
}